<template>
  <ul id="dock" class="brand-tools" v-scroll="handleScroll">
    <transition
      enter-active-class="animate__animated animate__fadeIn"
      leave-active-class="animate__animated animate__fadeOut"
    >
      <li v-show="isShow" class="tool back-top" @click="handleBackTop">
        <img src="@/assets/img/company/brand/top.png"></img>
      </li>
    </transition>
  </ul>
</template>

<script>
import { getScrollTopPosition, moveToScrollTop } from "@/utils/getScrollTop";
import { getScreenWH } from "@/utils/helpers";
import bezierEasing from "@/utils/bezier-easing.js";

const bezierEasingValue = "0.25, 0.8, 0.5, 1";
export default {
  name: "AppDock",
  data() {
    return {
      scrollTop: 0,
      windowHeight: 0,
      bezierEasingArray: bezierEasingValue.split(","),
    };
  },
  computed: {
    isShow() {
      return this.scrollTop > this.windowHeight;
    },
  },
  mounted() {
    this.handleScroll();
  },
  methods: {
    handleScroll() {
      this.windowHeight = getScreenWH().h;
      this.scrollTop = getScrollTopPosition();
    },
    handleBackTop() {
      this.scrollTo();
    },
    scrollTo() {
      let scrollTop = this.scrollTop;
      let easing = bezierEasing(...this.bezierEasingArray);
      let startingTime = null;
      let duration = 600;
      const step = (currentTime) => {
        if (!startingTime) startingTime = currentTime;
        let progress = currentTime - startingTime;
        let progressPercentage = progress / duration;
        if (progress >= duration) progress = duration;
        if (progressPercentage >= 1) progressPercentage = 1;

        // const offset = scrollTop;
        const perTick = scrollTop - easing(progressPercentage) * scrollTop;
        moveToScrollTop(perTick);
        if (progress < duration) {
          this.scrollAnimationFrame = window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    },
  },
};
</script>
<style lang="scss" scoped>
.brand-tools .back-top {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  height: 50px;
  width: 50px;
}
.brand-tools .back-top img {
  margin: auto;
}
</style>